<template>
  <v-simple-table mobile-breakpoint="0" class="table-balance-info">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center">{{ $t("page.profile.date") }}</th>
          <th class="text-center">{{$t('page.profile.description')}}</th>
          <th class="text-center">{{$t('page.profile.debit')}}</th>
          <th class="text-center">{{$t('page.profile.credit')}}</th>
          <th class="text-center">{{$t('page.profile.balance')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.date" class="tr-stretch">
          <td class="tb-wide0">{{ item.date }}</td>
          <td class="tb-wide">{{ item.description }}</td>
          <td>{{ formater(item.debit) }}</td>
          <td>{{ formater(item.credit) }}</td>
          <td>{{ formater(item.balance) }}</td>
        </tr>
      </tbody>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{$t('page.profile.account_balance_info')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          date: "1-JAN-2022",
          description: "REFERRAL FEE 1-DEC-2021 – 31-DEC-2021",
          debit: 0,
          credit: 25000000,
          balance: 25000000,
        },
        {
          date: "10-JAN-2022",
          description: "PAYMENT FROM VIRTU DIGILAB",
          debit: 25000000,
          credit: 0,
          balance: 25000000,
        },
        {
          date: "1-FEB-2022",
          description: "REFERRAL FEE 1-JAN-2021 – 31-JAN-2021",
          debit: 0,
          credit: 12750000,
          balance: 12750000,
        },
        {
          date: "10-FEB-2022",
          description: "PAYMENT FROM VIRTU DIGILAB",
          debit: 12750000,
          credit: 0,
          balance: 12750000,
        },
        {
          date: "1-MAR-2022",
          description: "REFERRAL FEE 1-FEB-2021 – 28-FEB-2021",
          debit: 0,
          credit: 30000000,
          balance: 30000000,
        },
        {
          date: "10-MAR-2022",
          description: "PAYMENT FROM VIRTU DIGILAB",
          debit: 30000000,
          credit: 0,
          balance: 30000000,
        },
      ],
    };
  },
  methods: {
    formater(value) {
      let angka = parseInt(value) || 0;
      let nilai = angka.toLocaleString("en-US", { minimumFractionDigits: 2 });
      return nilai;
    },
  },
};
</script>
<style>
.table-balance-info thead {
      background: #ddd !important;
      font-weight: bold;
      color: #000 !important;
  }
  .table-balance-info thead tr th{
      height: 38px !important;
  }
  .table-balance-info tbody tr td{
      font-size: 12px !important;
      height: 35px !important;
  }
  .table-balance-info tbody tr:hover{
      background-color: transparent !important;
  }
</style>
<style lang="scss" scoped>
@import "@/assets/scss/color.scss";

.v-input__control {
  width: 700px;
}

.v-toolbar__title {
  font-size: 16px;
}

.v-btn {
  display: flex;
  justify-content: flex-end;
}

.v-data-table td {
  font-size: 12px !important;
}
.text-custom {
  font-size: 12px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 12px !important;
}

</style>
